module.exports = __webpack_public_path__ + "static/media/document.a2ab5a71.png";